/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowwhenstart3Inputs */

const en_aiflowwhenstart3 = /** @type {(inputs: Aiflowwhenstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts`)
};

const de_aiflowwhenstart3 = /** @type {(inputs: Aiflowwhenstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginn`)
};

/**
* | output |
* | --- |
* | "Starts" |
*
* @param {Aiflowwhenstart3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowwhenstart3 = /** @type {((inputs?: Aiflowwhenstart3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowwhenstart3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowwhenstart3(inputs)
	return de_aiflowwhenstart3(inputs)
});
export { aiflowwhenstart3 as "aiFlowWhenStart" }